import { render, staticRenderFns } from "./BidsFilter.vue?vue&type=template&id=15f7ceb9&scoped=true&"
import script from "./BidsFilter.vue?vue&type=script&lang=js&"
export * from "./BidsFilter.vue?vue&type=script&lang=js&"
import style0 from "./BidsFilter.vue?vue&type=style&index=0&id=15f7ceb9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f7ceb9",
  null
  
)

export default component.exports